// Marketing-site base URL. Defaults to prod www; override for local dev by setting
// VITE_MAIN_SITE_URL in cm-app/.env.local (gitignored, never ships) — e.g.
// VITE_MAIN_SITE_URL=https://local.catalogmachine.com. Empty/unset -> www fallback.
export const MAIN_SITE_URL =
  import.meta.env.VITE_MAIN_SITE_URL || "https://www.catalogmachine.com";
export const HELP_CENTER = "https://help.catalogmachine.com/en/";
export const SUPPORT_MEETING_URL =
  "https://calendar.app.google/ikjrAmnjeVruoqH37";
